module.exports = __webpack_public_path__ + "img/searching.c1768bd6.svg";